import { all } from "redux-saga/effects";

import authAdminSaga from "./authAdminSaga";
import authTenantSaga from "./authTenantSaga";
import adjustmentOrderSaga from "./adjustmentOrderSaga";
import adminNotificationSaga from "./adminNotificationSaga";
import brandSaga from "./brandSaga";
import categorySaga from "./categorySaga";
import customerSaga from "./customerSaga";
import dashboardSaga from "./dashboardSaga";
import inventorySaga from "./inventorySaga";
import notificationSaga from "./notificationSaga";
import planSaga from "./planSaga";
import productSaga from "./productSaga";
import purchaseSaga from "./purchaseSaga";
import reportSaga from "./reportSaga";
import salesSaga from "./salesSaga";
import stockSaga from "./stockSaga";
import supplierSaga from "./supplierSaga";
import supportRequestSaga from "./supportRequestSaga";
import tenantSaga from "./tenantSaga";
import tenantSignupRequestSaga from "./tenantSignupRequestSaga";
import tenantDepartmentSaga from "./tenantDepartmentSaga";
import tenantUserSaga from "./tenantUserSaga";
import transactionSaga from "./transactionSaga";
import unitSaga from "./unitSaga";
import warehouseSaga from "./warehouseSaga";

export default function* rootSaga() {
  yield all([
    authAdminSaga(),
    authTenantSaga(),
    adjustmentOrderSaga(),
    adminNotificationSaga(),
    brandSaga(),
    categorySaga(),
    customerSaga(),
    dashboardSaga(),
    inventorySaga(),
    notificationSaga(),
    planSaga(),
    productSaga(),
    purchaseSaga(),
    reportSaga(),
    salesSaga(),
    stockSaga(),
    supplierSaga(),
    supportRequestSaga(),
    tenantSaga(),
    tenantSignupRequestSaga(),
    tenantDepartmentSaga(),
    tenantUserSaga(),
    transactionSaga(),
    unitSaga(),
    warehouseSaga(),
  ]);
}
